// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__11gD7","dragIcon":"Choice_dragIcon__2vsBO","left":"Choice_left__3DZKj","input":"Choice_input__2bteu"};